module.exports = __webpack_public_path__ + "static/image_16-7f57ba185112406be8ffc6b820f710f8.jpg";